export class AnnualLeavePlan {
  YOS;
  LeaveType;
  GradeEntitle;
  constructor() {
    this.YOS = 1;
    this.LeaveType = "";
    this.GradeEntitle = [];
  }
}



// WEBPACK FOOTER //
// ./src/model/AnnualLeavePlan.js